
import { useState } from 'react'
import { Link } from 'react-router-dom'
import ModalVideo from 'react-modal-video'
import "../../../node_modules/react-modal-video/css/modal-video.css"
export default function About1() {
	const [isOpen, setOpen] = useState(false)
	return (
		<>
			<section className="about-section fix section-padding" id="about">
				<div className="about-shape-1 float-bob-x">
					{/* <img src="assets/img/about/about-shape-1.png" alt="img" /> */}
				</div>
				<div className="about-shape-2 float-bob-x">
					{/* <img src="assets/img/about/about-shape-2.png" alt="img" /> */}
				</div>
				<div className="container">
					<div className="about-wrapper">
						<div className="row g-4">
							<div className="col-lg-6">
								<div className="about-image">
									<img
										src="assets/img/about/About.jpg"
										alt="img"
										className="wow fadeInLeft"
										data-wow-delay=".2s"
									/>
									{/* <div
										className="about-image-2 wow fadeInUp"
										data-wow-delay=".4s"
									>
										<img src="assets/img/about/02.jpg" alt="img" />
										<div className="video-box">
											<a
												onClick={() => setOpen(true)}
												className="video-btn video-popup"
											>
												<i className="fas fa-play" />
											</a>
										</div>
									</div> */}
									<div className="about-line-shape">
										<img src="assets/img/about/about-shape-3.png" alt="img" />
									</div>
								</div>
							</div>
							<div className="col-lg-6">
								<div className="about-content">
									<div className="section-title">
										<h6 className="wow fadeInUp">
											<i className="fa-regular fa-arrow-left-long" />
											about us
											<i className="fa-regular fa-arrow-right-long" />
										</h6>
										<h2 className="wow fadeInUp" data-wow-delay=".2s">
											Crafting Tomorrow's Doors – Today.
										</h2>
									</div>
									<p className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".4s">
										With a legacy of quality and innovation, V-Make is redefining what doors can do. Our{' '}
										<Link to="/Wpc-Doors" style={{ color: 'inherit', textDecoration: 'underline' }}>
											WPC door range
										</Link>{' '}
										is built for the demands of Indian homes — waterproof, termite-proof, and maintenance-free. From design to durability, every door reflects our commitment to next-gen living. Learn more about{' '}
										<a
											href="https://en.wikipedia.org/wiki/Wood-plastic_composite"
											target="_blank"
											rel="noopener noreferrer"
											style={{ color: 'inherit', textDecoration: 'underline' }}
										>
											wood-plastic composite materials
										</a>.
									</p>
									<h2 className="wow fadeInUp" data-wow-delay=".3s" style={{ fontSize: '1.5rem', marginTop: '1.5rem', marginBottom: '1rem' }}>
										Why Choose V-Make WPC Doors?
									</h2>
									<ul className="list-items wow fadeInUp" data-wow-delay=".2s">
										<li>
											{" "}
											<i className="fa-solid fa-circle-check" />
											Built to resist water, warping, and termites —{' '}
											<Link to="/faq" style={{ color: 'inherit', textDecoration: 'underline' }}>learn why</Link>
										</li>
										<li>
											{" "}
											<i className="fa-solid fa-circle-check" />
											Backed by 40+ years of expertise in door manufacturing
										</li>
										<li>
											{" "}
											<i className="fa-solid fa-circle-check" />
											Engineered for long life with{' '}
											<Link to="/Wpc-Door-Frames" style={{ color: 'inherit', textDecoration: 'underline' }}>zero maintenance</Link>
										</li>
									</ul>
									{/* <div className="about-author">
										<div
											className="author-image wow fadeInUp"
											data-wow-delay=".2s"
										>
											<img src="assets/img/news/Vishal(CEO).png" alt="author-img" width="70" height="70" />
											<div className="content">
												<p>XYZ, CEO</p>
												<h4>Director, V-Make Doors</h4>
											</div>
										</div>
										<img
											src="assets/img/about/signature.png"
											alt="img"
											className="wow fadeInUp"
											data-wow-delay=".4s"
										/>
									</div> */}
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<ModalVideo channel='youtube' autoplay isOpen={isOpen} videoId="JXMWOmuR1hU" onClose={() => setOpen(false)} />
		</>
	)
}
